/**
 * Helper para convertir rutas de imagen del backend a URLs accesibles
 */

const apiUrl = process.env.REACT_APP_LOAD_PAGE_URL || 'http://localhost:8080';
const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
export const DEFAULT_LOGO_URL = `${publicUrl}/img/logo.svg`;

const apiBase = apiUrl.replace(/\/$/, '');

const getBackendOrigin = () => {
  try {
    return new URL(apiBase).origin;
  } catch (_) {
    return apiBase;
  }
};

const normalizeImagePath = (imagePath) => {
  if (typeof imagePath !== 'string') {
    return '';
  }

  const normalized = imagePath.trim();
  if (!normalized) {
    return '';
  }

  const lower = normalized.toLowerCase();
  if (lower === 'null' || lower === 'undefined') {
    return '';
  }

  return normalized;
};

/**
 * Convierte una ruta de imagen del backend a una URL HTTP accesible
 * 
 * @param {string} imagePath - Ruta devuelta por el backend
 * @returns {string} - URL HTTP accesible
 * 
 * Ejemplos:
 * - "C:\Users\...\uploads\1\logo.png" → "http://localhost:8080/uploads/1/logo.png"
 * - "/uploads/1/logo.png" → "http://localhost:8080/uploads/1/logo.png"
 * - "http://..." → "http://..." (sin cambios)
 */
export const convertToImageUrl = (imagePath, fallback = DEFAULT_LOGO_URL) => {
  const normalizedPath = normalizeImagePath(imagePath);
  if (!normalizedPath) {
    return fallback;
  }

  // Si ya es una URL HTTP completa, devolverla tal cual
  if (normalizedPath.startsWith('http://') || normalizedPath.startsWith('https://')) {
    return normalizedPath;
  }

  // Si es una ruta local de Windows (contiene : o \), usar imagen por defecto
  if (normalizedPath.includes('\\')) {
    return fallback;
  }

  const backendOrigin = getBackendOrigin();

  // Recursos públicos servidos por backend (no bajo /api/v1)
  if (normalizedPath.startsWith('/uploads/')) {
    return `${backendOrigin}${normalizedPath}`;
  }

  if (normalizedPath.startsWith('uploads/')) {
    return `${backendOrigin}/${normalizedPath}`;
  }

  // Si empieza con /api/, probablemente es una ruta del backend
  if (normalizedPath.startsWith('/api/')) {
    return `${apiBase}${normalizedPath}`;
  }

  // Otra ruta absoluta del backend
  if (normalizedPath.startsWith('/')) {
    return `${backendOrigin}${normalizedPath}`;
  }

  return normalizedPath;
};

/**
 * Agrega cache busting a una URL de imagen
 */
export const addCacheBuster = (url) => {
  if (!url) return null;
  
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${new Date().getTime()}`;
};

/**
 * Convierte y agrega cache busting en un solo paso
 */
export const getImageUrl = (imagePath) => {
  const url = convertToImageUrl(imagePath, '');
  if (!url) {
    return DEFAULT_LOGO_URL;
  }
  if (url === DEFAULT_LOGO_URL) {
    return DEFAULT_LOGO_URL;
  }
  return addCacheBuster(url);
};

